import {
  breakpoints,
  DESKTOP_SCREEN_TYPE,
  MOBILE_SCREEN_TYPE,
  TABLET_SCREEN_TYPE,
} from "../constants/style";

const { md, lg } = breakpoints;

export const GetScreenType = () => {
  const { innerWidth } = typeof window !== "undefined" && window;
  if (innerWidth) {
    if (innerWidth > lg) {
      return DESKTOP_SCREEN_TYPE;
    }
    if (innerWidth <= lg && innerWidth >= md) {
      return TABLET_SCREEN_TYPE;
    }
    return MOBILE_SCREEN_TYPE;
  }

  return "";
};
